// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2019-01-25T10:29:42Z                      #

// ##############################################################

export function updateAdresa_CEF31D(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'AdresaVO',
    };


    return result;
}

export function updateMapAdresa_CEF31D(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateAdresa_CEF31D(data[key]);
    });
    return result;
}

export function updateListAdresa_CEF31D(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateAdresa_CEF31D);
}

export function updateKomunikaceVO_AE5518(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.stranaKomunikace !== "undefined") {
        result.stranaKomunikace = updateStranaKomunikace_5F1C45(data.stranaKomunikace);
    }
    if (typeof data.druhPovrchu !== "undefined") {
        result.druhPovrchu = updateDruhPovrchu_26BF37(data.druhPovrchu);
    }
    if (typeof data.typKomunikace !== "undefined") {
        result.typKomunikace = updateTypKomunikace_EAAD0D(data.typKomunikace);
    }
    if (typeof data.typ !== "undefined") {
        result.typ = updateTypObjektu_246369(data.typ);
    }

    return result;
}

export function updateMapKomunikaceVO_AE5518(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateKomunikaceVO_AE5518(data[key]);
    });
    return result;
}

export function updateListKomunikaceVO_AE5518(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateKomunikaceVO_AE5518);
}

export function updatePlochaVO_48FAFE(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.typ !== "undefined") {
        result.typ = updateTypObjektu_246369(data.typ);
    }

    return result;
}

export function updateMapPlochaVO_48FAFE(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updatePlochaVO_48FAFE(data[key]);
    });
    return result;
}

export function updateListPlochaVO_48FAFE(data) {
    if (data == null) {
        return data;
    }
    return data.map(updatePlochaVO_48FAFE);
}

export function updatePoloha_74BD54(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'PolohaVO',
    };

    if (typeof data.adresa !== "undefined") {
        result.adresa = updateAdresa_CEF31D(data.adresa);
    }
    if (typeof data.objektUmisteni !== "undefined") {
        result.objektUmisteni = updateAbstractObjekt_5F61A6(data.objektUmisteni);
    }

    return result;
}

export function updateMapPoloha_74BD54(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updatePoloha_74BD54(data[key]);
    });
    return result;
}

export function updateListPoloha_74BD54(data) {
    if (data == null) {
        return data;
    }
    return data.map(updatePoloha_74BD54);
}

export function updateObjektSearchResult_0273A3(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'ObjektSearchResultVO',
    };

    if (typeof data.objekt !== "undefined") {
        result.objekt = updateAbstractObjekt_5F61A6(data.objekt);
    }

    return result;
}

export function updateMapObjektSearchResult_0273A3(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateObjektSearchResult_0273A3(data[key]);
    });
    return result;
}

export function updateListObjektSearchResult_0273A3(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateObjektSearchResult_0273A3);
}

export function updateAbstractObjekt_5F61A6(data) {
    if (data == null) {
        return data;
    }

    if (!data["@class"]) {
        console.error("Objekt nemá definován typ třídy (atribut @class)", data);
        throw "Objekt nemá definován typ třídy (atribut @class)";
    }

    switch (data["@class"]) {
        case "ParcelaVO":
            return updateParcelaVO_903225(data);
        case "BudovaVO":
            return updateBudovaVO_2FA1C5(data);
        case "StavbaVO":
            return updateStavbaVO_E33686(data);
        case "KomunikaceVO":
            return updateKomunikaceVO_AE5518(data);
        case "PredmetVO":
            return updatePredmetVO_1CB0D7(data);
        case "PlochaVO":
            return updatePlochaVO_48FAFE(data);
        default:
            console.error("Nepodporovaný typ třídy (atribut @class)", data["@class"], data);
            throw "Nepodporovaný typ třídy (atribut @class) '" + data["@class"] + "'";
    }
}

export function updateMapAbstractObjekt_5F61A6(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateAbstractObjekt_5F61A6(data[key]);
    });
    return result;
}

export function updateListAbstractObjekt_5F61A6(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateAbstractObjekt_5F61A6);
}

export function updateStavbaVO_E33686(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.typ !== "undefined") {
        result.typ = updateTypObjektu_246369(data.typ);
    }

    return result;
}

export function updateMapStavbaVO_E33686(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateStavbaVO_E33686(data[key]);
    });
    return result;
}

export function updateListStavbaVO_E33686(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateStavbaVO_E33686);
}

export function updateTypObjektu_246369(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'TypObjektuVO',
    };


    return result;
}

export function updateMapTypObjektu_246369(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateTypObjektu_246369(data[key]);
    });
    return result;
}

export function updateListTypObjektu_246369(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateTypObjektu_246369);
}

export function updateDruhPovrchu_26BF37(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'DruhPovrchuVO',
    };


    return result;
}

export function updateMapDruhPovrchu_26BF37(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateDruhPovrchu_26BF37(data[key]);
    });
    return result;
}

export function updateListDruhPovrchu_26BF37(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateDruhPovrchu_26BF37);
}

export function updatePolohaVO_989CAF(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.adresa !== "undefined") {
        result.adresa = updateAdresa_CEF31D(data.adresa);
    }
    if (typeof data.objektUmisteni !== "undefined") {
        result.objektUmisteni = updateAbstractObjekt_5F61A6(data.objektUmisteni);
    }

    return result;
}

export function updateMapPolohaVO_989CAF(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updatePolohaVO_989CAF(data[key]);
    });
    return result;
}

export function updateListPolohaVO_989CAF(data) {
    if (data == null) {
        return data;
    }
    return data.map(updatePolohaVO_989CAF);
}

export function updateBudovaVO_2FA1C5(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.adresaList !== "undefined") {
        result.adresaList = updateListAdresa_CEF31D(data.adresaList);
    }
    if (typeof data.typ !== "undefined") {
        result.typ = updateTypObjektu_246369(data.typ);
    }

    return result;
}

export function updateMapBudovaVO_2FA1C5(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateBudovaVO_2FA1C5(data[key]);
    });
    return result;
}

export function updateListBudovaVO_2FA1C5(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateBudovaVO_2FA1C5);
}

export function updateTypKomunikace_EAAD0D(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'TypKomunikaceVO',
    };


    return result;
}

export function updateMapTypKomunikace_EAAD0D(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateTypKomunikace_EAAD0D(data[key]);
    });
    return result;
}

export function updateListTypKomunikace_EAAD0D(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateTypKomunikace_EAAD0D);
}

export function updatePredmetVO_1CB0D7(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.typ !== "undefined") {
        result.typ = updateTypObjektu_246369(data.typ);
    }

    return result;
}

export function updateMapPredmetVO_1CB0D7(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updatePredmetVO_1CB0D7(data[key]);
    });
    return result;
}

export function updateListPredmetVO_1CB0D7(data) {
    if (data == null) {
        return data;
    }
    return data.map(updatePredmetVO_1CB0D7);
}

export function updateObjektSearchResultVO_EB58D2(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.objekt !== "undefined") {
        result.objekt = updateAbstractObjekt_5F61A6(data.objekt);
    }

    return result;
}

export function updateMapObjektSearchResultVO_EB58D2(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateObjektSearchResultVO_EB58D2(data[key]);
    });
    return result;
}

export function updateListObjektSearchResultVO_EB58D2(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateObjektSearchResultVO_EB58D2);
}

export function updateStranaKomunikace_5F1C45(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'StranaKomunikaceVO',
    };


    return result;
}

export function updateMapStranaKomunikace_5F1C45(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateStranaKomunikace_5F1C45(data[key]);
    });
    return result;
}

export function updateListStranaKomunikace_5F1C45(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateStranaKomunikace_5F1C45);
}

export function updateKU_22EA44(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'KuVO',
    };


    return result;
}

export function updateMapKU_22EA44(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateKU_22EA44(data[key]);
    });
    return result;
}

export function updateListKU_22EA44(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateKU_22EA44);
}

export function updateParcelaVO_903225(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.ku !== "undefined") {
        result.ku = updateKU_22EA44(data.ku);
    }
    if (typeof data.typ !== "undefined") {
        result.typ = updateTypObjektu_246369(data.typ);
    }

    return result;
}

export function updateMapParcelaVO_903225(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateParcelaVO_903225(data[key]);
    });
    return result;
}

export function updateListParcelaVO_903225(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateParcelaVO_903225);
}
